export function isNotScalar<T>(
    value: T,
): value is Exclude<T, string | number | boolean | undefined | null> {
    return (
        typeof value !== 'number' &&
        typeof value !== 'string' &&
        typeof value !== 'boolean' &&
        typeof value !== 'undefined' &&
        value !== null
    );
}
